import { CommonModule } from '@angular/common';
import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { DetectionRuleSeverity } from 'src/app/models/api/finding.model';

export type Severities = Record<DetectionRuleSeverity, number>;

@Component({
  selector: 'app-severities-cell',
  standalone: true,
  templateUrl: './severities-cell.component.html',
  styleUrls: ['./severities-cell.component.scss'],
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.interactable]': 'interactable()',
  },
})
export class SeveritiesCellComponent {
  severities = input.required({
    transform: (value: Severities): [DetectionRuleSeverity, number][] => [
      [DetectionRuleSeverity.critical, value[DetectionRuleSeverity.critical] ?? 0],
      [DetectionRuleSeverity.high, value[DetectionRuleSeverity.high] ?? 0],
      [DetectionRuleSeverity.medium, value[DetectionRuleSeverity.medium] ?? 0],
      [DetectionRuleSeverity.low, value[DetectionRuleSeverity.low] ?? 0],
      [DetectionRuleSeverity.informational, value[DetectionRuleSeverity.informational] ?? 0],
    ],
  });

  showSeverityCount = input<boolean>(true);
  interactable = input<boolean>(false);

  protected barsFilledWithColorForSevery = {
    [DetectionRuleSeverity.critical]: 4,
    [DetectionRuleSeverity.high]: 3,
    [DetectionRuleSeverity.medium]: 2,
    [DetectionRuleSeverity.low]: 1,
    [DetectionRuleSeverity.informational]: 0,
  };
}
